(function () {
document.addEventListener("DOMContentLoaded", function() {
    var _loop = function(i) {
        var _loop = function(o) {
            var accordion = accordions[o];
            var button = accordion.querySelector(".accordion__button");
            var content = accordion.querySelector(".accordion__content");
            button.addEventListener("click", function(evt) {
                // if (evt.target.tagName.toLowerCase() !== 'a') {
                if (!accordion.classList.contains("accordion--active")) {
                    var activeAccordion = wrapper.querySelector(".accordion--active");
                    if (activeAccordion) {
                        var activeButton = activeAccordion.querySelector(".accordion__button");
                        var activeContent = activeAccordion.querySelector(".accordion__content");
                        activeAccordion.classList.remove("accordion--active");
                        activeButton.setAttribute("aria-expanded", false);
                        activeContent.setAttribute("aria-hidden", true);
                    }
                    accordion.classList.add("accordion--active");
                    button.setAttribute("aria-expanded", true);
                    content.setAttribute("aria-hidden", false);
                } else {
                    accordion.classList.remove("accordion--active");
                    button.setAttribute("aria-expanded", false);
                    content.setAttribute("aria-hidden", true);
                }
            // }
            });
        };
        // Variables
        var wrapper = wrappers[i];
        var accordions = wrapper.querySelectorAll(".accordion");
        for(var o = 0; o < accordions.length; o++)_loop(o);
    };
    // Variables
    var wrappers = document.getElementsByClassName("content-accordions");
    // Initializing Items
    for(var i = 0; i < wrappers.length; i++)_loop(i);
});

})();
//# sourceMappingURL=content-accordions.js.map
